export default "__VITE_ASSET__CxHMckpN__"